import { module as BaseModule } from 'modujs'
export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.dir = window.location.pathname
    this.isEnglish = this.dir.includes('fr') ? false : true

    this.setLanguage()
    this.setUrl()
  }

  setLanguage() {
    this.active = this.el.querySelector('.languageActive')
    this.inactive = this.el.querySelector('.languageInactive')

    this.active.innerHTML = this.isEnglish ? 'EN' : 'FR'
    this.inactive.innerHTML = this.isEnglish ? 'FR' : 'EN'
  }
  setUrl() {
    this.isEnglish
      ? (this.el.href = '/fr' + this.dir)
      : (this.el.href = this.dir.replace('/fr', ''))
  }
}
